import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import SectionTitle from "./SectionTitle";

const About = () => {
  return (
    <div
      id="about"
      className="w-full md:min-h-screen flex flex-col items-center md:items-start justify-center px-4 md:px-20 py-20"
    >
      <SectionTitle highlight="Some info" section="About me" />
      <div className="w-full flex flex-col-reverse md:flex-row text-center md:text-left  md:px-20 items-center justify-between">
        <div className="md:w-2/3 flex flex-col items-start justify-between md:pr-20">
          <p className="font-custom font-normal text-xl 2xl:text-2xl text-black my-4">
            I am a{" "}
            <span className="text-primary font-semibold">Javascript</span>{" "}
            developer that focuses on frontend frameworks such as{" "}
            <span className="text-primary font-semibold">
              React, Gatsby & Nextjs
            </span>{" "}
            with a background in computer science. My 2 years of IT experience
            has given me a good foundation for{" "}
            <span className="text-primary font-semibold">
              web development and building complex
            </span>{" "}
            solutions.
          </p>
          <p className="font-custom font-normal text-xl 2xl:text-2xl text-black my-4">
            I have a passion for{" "}
            <span className="text-primary font-semibold">
              Headless e-commerce, Design systems and Serverless Technologies.
            </span>
            Currently I’m focusing on building{" "}
            <span className="text-primary font-semibold">JAM Stack</span>{" "}
            applications and{" "}
            <span className="text-primary font-semibold">AWS CDK.</span> I have
            also contributed in Open source to help people learn AWS CDK is the
            easiest way possible. And I am excited to work alongside other
            amazing programmers and learn so much more!
          </p>
          <p className="font-custom font-normal text-xl 2xl:text-2xl text-black my-4">
            If you're looking for a{" "}
            <span className="text-primary font-semibold">
              developer to add to your team
            </span>
            , I'd love to hear from you!
          </p>
        </div>
        <div className="md:w-1/3">
          <StaticImage
            src="../images/About.jpg"
            alt="About Image"
            layout="constrained"
            placeholder="blurred"
            className="w-80 h-96 object-contain rounded-2xl shadow-2xl border border-gray-300"
          />
        </div>
      </div>
    </div>
  );
};

export default About;
